import { render } from "./EditContract.vue?vue&type=template&id=6739e936"
import script from "./EditContract.vue?vue&type=script&lang=js"
export * from "./EditContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__